import { useGlobalContext } from "../../../../Context/Context";
import Button from "../../../Custom/Button/Button";

const obrazci = ["FIRMA A", "FIRMA B", "FIRMA C"];

function ShowBarPoslovniSaradnici() {
  const { selectedPoslovniSaradnici, setSelectedPoslovniSaradnici } =
    useGlobalContext();

  const handleClickObrazac = (index) => {
    if (selectedPoslovniSaradnici !== index + 1) {
      setSelectedPoslovniSaradnici(index + 1);
    } else {
      setSelectedPoslovniSaradnici(0);
    }
  };

  return (
    <div style={{ backgroundColor: "white" }}>
      {obrazci.map((obrazac, i) => (
        <div onClick={() => handleClickObrazac(i)}>
          <Button
            active={selectedPoslovniSaradnici === i + 1}
            style={{
              padding: "7px",
              fontWeight: "bold",
              textAlign: "left",
              minHeight: "64px",
              display: "block",
              fontSize: "16px"
            }}
          >
            {obrazac}
          </Button>
        </div>
      ))}
    </div>
  );
}

export default ShowBarPoslovniSaradnici;
